import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FileFormats } from "../../../components/forms/libs/data/fileFormatTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import Buttons from "../../../components/ui/button/Buttons";

const initState = {
    eventName: null,
    eventDate: null,
    startTime: null,
    endTime: null,
    certificateFor: null,
};

export const ManualCertFormData = {
    name: "ManualCertFormData",
    initialState: initState,
    section: [
        {
            title: "ManualCertFormData",
            row: {},
            style: {
                sectionStyle: "row verticle-form",
            },
            fields: [
                {
                    id: "eventName",
                    label: "Event/Course Name",
                    Field_Name: "Event",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "eventName",
                    fieldSetting: {
                        allowSpace: true,
                        placeholder: "Event/Course Name",
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
                    },
                },
                {
                    id: "eventDate",
                    label: "Event/Course Date",
                    Field_Name: "Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "eventDate",
                    fieldSetting: {
                        placeholder: "dd-mmm-yyyy",
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
                    },
                },

                {
                    id: "startTime",
                    label: "Start Time",
                    Field_Name: "Start Time",
                    fieldType: FormFieldTypes.TIMEPICKER,
                    dataField: "startTime",
                    fieldSetting: {},
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-4 validation-left-0 mb-3",
                    },
                },
                {
                    id: "endTime",
                    label: "End Time",
                    Field_Name: "End Time",
                    fieldType: FormFieldTypes.TIMEPICKER,
                    dataField: "endTime",
                    fieldSetting: {},
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-4 validation-left-0 mb-3",
                    },
                },
                {
                    id: "certificateFor",
                    label: "Certificate For",
                    Field_Name: "CertificateFor",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "certificateFor",
                    fieldSetting: {
                        placeholder: "Select",
                        options: [{ value: "Event", label: "Event" }, { value: "Course", label: "Course" }],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
                    },
                },
            ],
        },
    ],
};
